import React from "react";

import estilo from "./styles/Cargando.module.css";

function Cargando() {
  return (
    <div className={estilo.cargando}>
      <div className={estilo.slider}>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}

export default Cargando;
